module.exports = __webpack_public_path__ + "img/sv24.3743121f.svg";